import React, { useState } from 'react';
import { Button } from '@mui/material';
import { alpha, useTheme } from '@mui/material/styles';

const ImageGallery = ({ images, loading, onConfirmSelection }) => {
  const theme = useTheme();
  const [selectedImages, setSelectedImages] = useState([]);

  const floatingButtonStyle = {
    position: 'fixed',
    bottom: '20px',
    right: '20px',
    zIndex: 1000,
    padding: '12px 24px',
    backgroundColor: theme.palette.primary.main,
    color: theme.palette.primary.contrastText,
    border: 'none',
    borderRadius: '8px',
    cursor: 'pointer',
    boxShadow: `0 4px 8px ${alpha(theme.palette.common.black, 0.2)}`,
  };

  const galleryStyle = {
    display: 'grid',
    gridTemplateColumns: 'repeat(3, 1fr)',
    gap: '16px',
    padding: '20px',
  };

  const buttonStyle = {
    border: 'none',
    padding: 0,
    background: 'none',
    cursor: 'pointer',
    borderRadius: '12px',
    overflow: 'hidden',
    boxShadow: `0 4px 8px ${alpha(theme.palette.common.black, 0.1)}`,
    transition: 'all 0.2s',
  };

  const imageStyle = {
    width: '100%',
    height: 'auto',
    display: 'block',
  };

  const toggleSelectImage = (url) => {
    setSelectedImages((prevSelected) =>
      prevSelected.includes(url)
        ? prevSelected.filter((img) => img !== url)
        : [...prevSelected, url]
    );
  };

  const handleAction = () => {
    console.log('Imágenes seleccionadas:', selectedImages);
    onConfirmSelection && onConfirmSelection(selectedImages)
    // Acá podés hacer algo con las seleccionadas
  };

  if (loading) return <p>Cargando imágenes...</p>;

  return (
    <div>
      <div style={galleryStyle}>
        {images.map((url, index) => {
          const isSelected = selectedImages.includes(url);
          return (
            <button
              key={index}
              onClick={() => toggleSelectImage(url)}
              style={{
                ...buttonStyle,
                border: isSelected ? `3px solid ${theme.palette.primary.main}` : 'none',
                opacity: isSelected ? 0.7 : 1,
              }}
            >
              <img src={url} alt={`imagen-${index}`} style={imageStyle} />
            </button>
          );
        })}
      </div>

      {selectedImages.length > 0 && (
        <div style={{ textAlign: 'center', marginTop: '20px' }}>
          {selectedImages.length > 0 && (
            <Button onClick={handleAction} style={floatingButtonStyle}>
              Confirmar seleccion de {selectedImages.length} imagen(es)
            </Button>
          )}
        </div>
      )}
    </div>
  );
};

export default ImageGallery;
